import { BlogEntityTypeEnum } from '@/fo/api/magento';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { ArticleItem } from './types';

export const articleItems: ArticleItem[] = [
  {
    id: 1,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/1',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    rating: 4.5,
    tag: {
      title: 'Жирная кожа и несовершенства',
      color: '#00C389'
    },
    avatar: staticMediaUrl('blog/avatar.png'),
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 2,
    title:
      'Как продлить эффект от дорогостоящих инъекционных и апп  аратных методик?',
    href: '/article/2',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    rating: 4.5,
    tag: {
      title: 'Продление молодости',
      color: '#582C83'
    },
    avatar: staticMediaUrl('blog/avatar.png'),
    doctorAvatar: staticMediaUrl('blog/doctor-avatar.png'),
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 3,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/3',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 4,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/4',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 5,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/5',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 6,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/6',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 7,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/7',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 8,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/8',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 9,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/9',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 10,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/10',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 11,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/11',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 12,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/12',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 13,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/13',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 14,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/14',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 15,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/15',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 16,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/16',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 17,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/17',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  },
  {
    id: 18,
    title: 'Салициловая кислота: руководство по применению',
    description: 'Что советует искусственный интеллект и что советует врач',
    href: '/article/18',
    date: '08.02.2025',
    readTime: '10 мин',
    image: 'https://placeholder.pagebee.io/api/plain/500/500',
    type: BlogEntityTypeEnum.Article
  }
];
